// imove-behavior: 添加到上报队列

export default async function(ctx) {
  const { payload = {} } = ctx;
  const { eventCode = '', params = {} } = payload;
  const task = {
    eventName: eventCode,
    reportObj: params,
  }
  return task;
}